<template>
    <div id="app">
        <loading v-if="false"></loading>
        <router-view v-wechat-title="$route.meta.title"/>
    </div>
</template>

<script>
    import loading from './plugin/loading/loading'

    export default {
        name: 'app',
        components: {
            loading
        },
        mounted(){
            console.log('mounted...',new Date().getTime());
            this.removeIndexLoading();
        },
        methods: {
            removeIndexLoading(){
                const domIndexLoading = document.getElementById('i_loading');
                if (domIndexLoading) {
                    const parent = domIndexLoading.parentElement;
                    //移除入口页loading
                    parent.removeChild(domIndexLoading)
                }
            }
        }
    }
</script>
